
import { Location } from '@angular/common';
import { HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { ApiGateway, CompanyAccountPlan, PageOptions } from 'cw-backend';
import { CwUtils } from 'cw-utils';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class CompanyAccountPlanListProvider implements Resolve<any> {
    companyAccountPlan: CompanyAccountPlan[];
    companyAccountPlanEdit: CompanyAccountPlan;
    onDataChanged: BehaviorSubject<any>;
    routeParams: any;
    state: any;
    pageOptions: PageOptions;
    currentPage: PageOptions;

    constructor(
        public gw: ApiGateway,
        private location: Location,
    ) {
        this.onDataChanged = new BehaviorSubject({});
    }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any {
        this.routeParams = route.params;

        // Get state for current or new page
        this.state = this.location.getState();
        this.currentPage = this.state?.currentPage;
        this.companyAccountPlanEdit = this.state?.currentCompanyAccountPlan;

        if (this.currentPage) {
            this.pageOptions = this.currentPage;
        }
        else {
            this.pageOptions = new PageOptions();
            this.pageOptions.fieldSort = 'id';
        }
        return new Promise<void>((resolve, reject) => {
            Promise.all([
                this.getPage(this.pageOptions)
            ]).then(
                () => {
                    resolve();
                },
                reject
            );
        });
    }

    get(id: number): Observable<CompanyAccountPlan> {
        if (!id) {
            return null;
        }
        return this.gw.get('companyAccountPlan/:id', { id: id });
    }

    get currentCompanyAccountPlan(): CompanyAccountPlan {
        return this.companyAccountPlanEdit;
    }

    getAll(): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.get('companyAccountPlan/').subscribe((res: HttpResponse<any>) => {
                this.companyAccountPlan = res.body;
                resolve(res);
            }, reject);
        });

    }

    getPage(pageOptions: PageOptions): Promise<any> {
        return new Promise((resolve, reject) => {
            this.gw.post('companyAccountPlan/search', pageOptions).subscribe((res: HttpResponse<any>) => {
                if (!CwUtils.compare(this.companyAccountPlan, res.body.content) && res.body.content.length > 0) {
                    this.companyAccountPlan = res.body.content;
                    this.onDataChanged.next(this.companyAccountPlan);
                }
                else {
                    this.companyAccountPlan = res.body.content;
                };
                resolve(res);
            }, reject);
        });
    }

    getPageSettings() {
        if (this.currentPage) {
            return this.pageOptions;
        } else {
            return;
        }
    }
}

